
import { Component, Vue } from 'vue-property-decorator';
import { getStayRoomSpecialPriceList, deleteStayRoomSpecialPrice } from '@/api/stayRoomSpeicalPrice';
import { getStayRoomListAll } from '@/api/stayRoom';
import Pagination from '@/components/Pagination/index.vue';
import StayRoomSpecialPriceForm from './components/form.vue';

@Component({
  components: {
    Pagination,
    StayRoomSpecialPriceForm,
  },
})
export default class extends Vue {
  mounted() {
    this.getRoomList();
    this.getList();
  }

  private loading = true;

  private listQuery = {
    page: 0,
    size: 10,
    startDate: '',
    endDate: '',
    roomIdx: null,
    reason: '',
  }

  private dateRange = [];

  private totalElements = 0;

  private itemList = [];

  private roomList = [];

  private formVisible = false;

  private formIdx = null;

  private getList() {
    this.loading = true;
    getStayRoomSpecialPriceList(this.listQuery).then((res) => {
      this.totalElements = res.data.totalElements;
      this.itemList = res.data.content;
      this.loading = false;
    });
  }

  private getRoomList() {
    getStayRoomListAll().then((res) => {
      this.roomList = res.data;
    });
  }

  private handleDelete(item: any) {
    this.$confirm(`정말 특가[${item.stayRoom.name} (${item.targetDate})]를 삭제하시겠습니까?`, '특가 삭제', {
      confirmButtonText: '예',
      cancelButtonText: '아니오',
      type: 'error',
    }).then(() => {
      deleteStayRoomSpecialPrice(item.idx).then(() => {
        this.$message.success('답글을 삭제했습니다.');
        this.getList();
      });
    });
  }

  /* eslint-disable */
  private handleChangeDateRange() {
    if (this.dateRange && this.dateRange.length === 2) {
      this.listQuery.startDate = this.dateRange[0];
      this.listQuery.endDate = this.dateRange[1];
    } else {
      this.listQuery.startDate = '';
      this.listQuery.endDate = '';
    }
  }
  /* eslint-enable */

  private handleSearch() {
    this.listQuery.page = 0;
    this.getList();
  }

  private handleVisibleForm(idx: any) {
    this.formIdx = idx;
    this.formVisible = !this.formVisible;
  }

  private handleSave() {
    this.handleVisibleForm(null);
    this.getList();
  }

  private getNumber(index: number) {
    let totalSize = (this.listQuery.page - 1) * this.listQuery.size;
    if (totalSize < 0) totalSize = 0;
    return this.totalElements - totalSize - index;
  }
}
